<template>
    <b-container class="container-card" v-bind:class="viewType" id="CG">
        <div class="menuTopCont" v-if="showControls">
            <b-button class="menuTop" :pressed="viewType == 'info'" @click="viewType = 'info'">{{ $t("messages.info") }}</b-button>
            <b-button :disabled="!pool.present" class="menuTop" :pressed="viewType == 'config'" @click="setConfig">{{ $t("messages.config") }}</b-button>
            <b-button class="menuTop" :pressed="viewType == 'alarms'" @click="viewType = 'alarms'">{{ $t("messages.alarms") }}</b-button>
            <b-button class="menuTop" :pressed="viewType == 'stats'" @click="viewType = 'stats'">{{ $t("messages.stats") }}</b-button>
        </div>
        <div class="menuTopCont" v-else>
            <!-- <b-button class="menuTop">Edit pool </b-button> -->
            <router-link class="menuTop" :to="`/pool-detail/${pool.id}`"> {{ $t("messages.edit") }} </router-link>
        </div>
        <b-row class="card-globalBody">
            <b-col md="4" sm="12" class="pool-info">
                <div class="card-main text-right">
                    <div v-if="face === 'smile'" class="face smile" :id='pool.id'></div>
                    <div v-if="face === 'regular'" class="face regular" :id='pool.id'></div>
                    <div v-if="face === 'sad'" class="face sad" :id='pool.id'></div>
                    <div v-if="face === 'filt'" class="face filt" :id='pool.id'><span>Filtración desactivada</span></div>
                    <h1 v-bind:class="getNameClass(poolName(pool.form))"> {{ poolName(pool.form) }}</h1>
                    <p style="font-size:12px">{{ pool.id }}</p>
                    <p style="font-size:12px" v-if="pool.main">{{ $t("messages.deviceDate") }}: <strong>  <span>  {{ getLocalTime(pool.main.localTime)}} </span></strong></p>
                    <div class="card-info">
                        <div class="weather">
                            <div class="w100" v-if="viewType != 'config'">
                                <b-button v-if="poolLocation" @click="showPoolMap" size="mini"><icon name="map-marker-alt"></icon></b-button>
                                <span class="tlocation" v-if="poolLocation.position" :id="'map-'+pool.id"> </span> 
                                <span class="tlocation twetlocationather">{{ pool.form.city}} {{ (pool.form.street!=null) ? ' - '+pool.form.street : '' }}</span>
                                <span class="tweather">  {{ getWeather(pool.id) }} </span>
                                <img :src="weatherIcon" width="60" class="iweather"/>
                            </div>
                            <div style="clear:both;"></div>
                            <div class="w100 inputSearch" v-if="viewType === 'config' && !pool.isDemo">
                                <!-- EDIT POOL INFO -->
                                <router-link class="btn" :to="`/pool-detail/${pool.id}`"> {{ $t("messages.poolInfoEdit") }}</router-link>
                            </div>
                        </div>
                    </div>
                    <div v-if="viewType == 'config'" class="contLocalTime">
                        <!-- <span class="tweather" style="font-size:14px"> {{ $t("messages.deviceDate")}}: {{ getLocalTime(pool.main.localTime)}}</span>  -->
                        <!-- Select date and time -->
                        <div style="position:relative;clear:both;float:left;margin-top:10px;width:100%;">
                         <el-date-picker
                            v-model="value3"
                            type="datetime"
                            :placeholder=' $t("messages.dateAndTime")'
                            format="dd/MM/yyyy HH:mm"
                            value-format="timestamp" :clearable="false">
                        </el-date-picker>
                        <b-button @click="saveLocalTime" size="mini" style="margin-top:5px"><icon name="save"></icon></b-button>
                        </div>
                        <div style="clear:both;"></div>
                    </div>
                    <div style="clear:both;"></div>
                </div>
            </b-col>
            <b-col md="8" sm="12" v-if="viewType == 'info'">
                <b-alert v-if="pool.awaitChanges" show variant="warning"><md-icon>info</md-icon> Hay cambios pendientes de confirmación  </b-alert> 
                <b-alert v-if="!pool.present" show variant="info"><md-icon>wifi_off</md-icon> {{ $t("messages.poolNotConnected") }} - {{ $t("messages.lastUpdate") }}:{{ pool.updatedAt | moment("DD-MM-YYYY HH:mm") }}</b-alert> 
                <div class="card-detail text-left">
                    <div class="infoMode">
                        <div v-if="pool.main">
                            <p v-if="!pool.main.hideFiltration" class="item">{{ $t("messages.filtration") }}:<strong>  <span> {{ getFiltrationMode(pool.filtration.mode)}}</span> - <span v-bind:class = "(pool.filtration.status === 1)?'green':'red'"> {{ (pool.filtration.status == 0)? 'OFF' : 'ON'}} </span></strong></p>
                            <p v-if="!pool.main.hideLighting" class="item"> {{ $t("messages.lighting") }}: <strong>  <span>  {{ getLightMode(pool.light)}} </span> - <span v-bind:class = "(pool.light.status === 1)?'green':'red'"> {{ getLightStatus(pool.light)}}</span></strong></p>
                        </div>
                        <p class="item" v-if="pool.hidro">{{ (pool.hidro.is_electrolysis) ? $t("messages.electro") :  $t("messages.hidro") }}: <strong>  <span> {{pool.hidro.current / 10 }} {{pool.hidro.measure}} </span></strong></p>
                        <div v-if="pool.main">
                            <p v-if="!pool.main.hideTemperature" class="item">{{ $t("messages.temperature") }}: <strong>  <span> {{pool.main.temperature }} ºC </span></strong></p>
                        </div>
                         <b-col md="8" sm="12" class="mtop20">
                            <b-row md="8" sm="12">
                                <!-- <b-button v-if="showAl3()" @click="resetAL3()" pill variant="outline-danger" size="sm" class='red'>AL3 - {{ $t("messages.al3") }}</b-button> -->
                                <p class="item" v-if="showAl3()"> <strong>  <span class='red'> AL3 </span></strong></p> 
                                <p class="item" v-if="showAl4()"> <strong>  <span class='red'> AL4 </span></strong></p> 
                                <p class="item" v-if="showFL1()"> <strong>  <span class='red'> FL1 </span></strong></p> 
                                <p class="item" v-if="showFL2()"> <strong>  <span class='red'> FL2 </span></strong></p> 
                                <p class="item" v-if="showTank()"> <strong>  <span class='red'> TANK </span></strong></p> 
                                <p class="item" v-if="showLow()"> <strong>  <span class='red'> LOW </span></strong></p> 
                            </b-row>
                         </b-col>
                        <div v-if="pool.main && pool.hidro && pool.filtration">
                            <modules :present="pool.present" :modules-info="pool.modules" :main-values="pool.main" :hidro-info="pool.hidro" :filtration-status="pool.filtration.status" v-on:onChangeColor="onChangeColor"></modules>
                        </div>
                    </div>
                </div>
            </b-col>
            <b-col md="8" sm="12" class="contConfig" v-else-if="viewType == 'config'">
                <config :modules-info="pool"></config>
            </b-col>
            <b-col md="8" sm="12" v-else-if="viewType == 'stats'">
                <stats :pool-data="pool"></stats>
            </b-col>
            <b-col md="8" sm="12"  v-else-if="viewType == 'alarms'">
                <alarms :pool-data="pool"></alarms>
            </b-col>
        </b-row>
        <transition>
            <modal :name="'map-'+pool.id"
            transition="nice-modal-fade"
            :width = 650
            :height = 360
            :pivot-y="0.5"
            :adaptive="true"
            :reset="true"
            :clickToClose="true">
                <div class="box-modal">
                    <div slot="top-right">
                        <b-btn @click="$modal.hide('map-'+pool.id);" class="closePopup"> <icon name="times-circle"></icon> </b-btn>
                    </div>
                <b-row>
                    <map-geo :initial-pos="poolLocation" :poolId="pool.id" :showEdit="true" ref="mapDetail"></map-geo>
                </b-row>               
                 </div>
            </modal>
        </transition>
    </b-container>
</template>

<script>
import { mapState} from 'vuex'
import Modules from './Modules.vue'
import Stats from './Stats.vue'
import Config from './Config.vue'
import Alarms from './Alarms.vue'
import MapGeo from './Map-geo.vue'
import PoolForm from './Pool-form.vue'

export default {
    name: 'PoolGlobal',
    components:{ 
        Modules,
        Config,
        Alarms,
        Stats,
        MapGeo,
        PoolForm
    },
    props: {
        pool: {},
        view: 'info',
        mode: String
    },
    data() {
        return {
            viewType: 'info',
            mapPopOverShow: null,
            weatherIcon: null,
            copyTimeDate: null,
            face: 'smile',
            value3: null
        }
    },
    watch: {
        'pool': {
            handler(value) {
             if(value.present === false){
                 this.viewType = 'info'
             }
            },
        }
    },
    computed: {
        ...mapState(['bg', 'currentUser']),

        showControls:{
            get(){
                return (this.mode == 'slide')
            }
        },

        poolLocation: {
            get(){
                let res = false
                let position = {
                    lat: String(this.pool.form.lat).replace(/,/g, '.'),
                    lng: String(this.pool.form.lng).replace(/,/g, '.'),
                }
                if(position.lat && position.lat != 'undefined' && position.lng && position.lng != 'undefined'){
                    res = {position}
                }
                return res
            }
        }
    },

    methods: {
        poolName(item){

        try{
            if(item.names && item.names.length>0){
                for (var uid of Object.keys(item.names)) {
                    if(this.currentUser.uid == item.names[uid].user){
                        return item.names[uid].name
                    } 
                }
            }
        }catch(err){
            console.log(err);
        }
        return item.name; //Default name instead
        },
        setConfig(){
            this.value3 = null
            this.viewType = 'config'
        },
        onChangeColor(type){
            this.face = type;
        },
        saveLocalTime() {
            let d = this.$moment.utc(this.value3).unix()
             if((new Date(d) !== "Invalid Date") && !isNaN(new Date(d))){
                let _d = new Date(this.value3)
                let millisec= _d.getTime() - (_d.getTimezoneOffset() * 60000);
                let seconds = millisec / 1000
                // let low = seconds & 0xFFFF //MBF_PAR_TIME_LOW
                // let high =  (seconds >> 16) & 0xFFFF
                // let commands = '1032:'+ low + ',1033:'+high+',1264:1'
                this.sendCommand(seconds)
             }

        },
        getNameClass(name) {
            var result = [];
            if (name.length > 12) {
                result.push('card-title card-title-xs')
            }else{
                result.push('card-title')
            }
            return result;
        },
        showAl3() {
            try{
                if(this.pool.modules.ph.al3 &&  (this.pool.modules.ph.current > this.pool.modules.ph.status.high_value || this.pool.modules.ph.current < this.pool.modules.ph.status.low_value)){
                return true;
                }
            }catch(err){
                return false;
            }
            return false;
        },
        showAl4() {
            try{
                if(this.currentUser.company !=3 && this.pool.main.hasHidro && this.pool.hidro.al4){
                return true;
                }
            }catch(err){
                return false;
            }
            return false;
        },
        showFL1() {
         try{
            if(this.pool.hidro.fl1){
                return true;
            }
        }catch(err){
            return false;
        }
            return false;
        },
        showFL2() {
            try{
                if(this.pool.main.hasCL && this.pool.hidro.fl2){
                    return true;
                }
           }catch(err){
            return false;
        }
            return false;
        },
        showTank() {
        try{
            if(this.pool.modules.ph.tank || this.pool.modules.rx.tank || this.pool.modules.cl.tank || this.pool.modules.cd.tank){
                return true;
            }
        }catch(err){
            return false;
        }
            return false;
        },
        showLow() {
            try{
                if(this.pool.hidro.low == 1){
                    return true;
                }
            }catch(err){
                return false;
            }
            return false;
        },
        onClose () {
            this.mapPopOverShow = false;
        },

        getLocalTime(time){
            return this.$moment.unix(time).utc().format('DD-MM-YYYY HH:mm')
        },


        getWeather(id) {
            let data = this.$store.getters.getCachedWeather(id);
            let msg = ''
            if(data && data.icon){
                msg = data.temp+'Cº - '+data.description    
                var images = require.context('../assets/weather-icons/bgwhite', false, /\.svg$/)
                this.weatherIcon = images('./' + data.icon + ".svg")
            }
            return msg;
        },

        getLightMode(light) {
            var _auto = this.$t("messages.auto").toUpperCase();
            var _manual = this.$t("messages.manual").toUpperCase();
            var mode = (light.mode == 1) ? _auto : _manual;
            return mode
        },
        getLightStatus(light) {
            var status = (light && light.status == 1) ? 'ON' : 'OFF';
            return status
        },
        getFiltrationMode(val){
            var _str = "messages."+this.$store.getters.getFiltrationMode(val).toLowerCase();
            return this.$t(_str).toUpperCase();
        },
        showPoolMap () {
            this.$modal.show('map-'+this.pool.id);
        },
        resetAL3() {
            let commands = 'resetAl3'
            this.sendCommand(commands)
        },
        sendCommand(time){
            // Connecting to the pool / Sending data
            this.$snotify.async( this.$t("messages.alertConnectingPool"),  this.$t("messages.alertSendingData"), () => new Promise((resolve, reject) => {
                console.log('is demo');
                this.$store.dispatch('sendPoolCommandAWS', {
                    'wifi': this.pool.wifi, 
                    'id': this.pool.id, 
                    'changes': JSON.stringify( {'main':{'localTime':time}}),
                    'pool': this.pool
                }).then(response => {
                   resolve({
                    //    The pool has recieved the new configuration
                        body: this.$t("messages.configRecieved"),
                        config: {
                            timeout: 3000,
                            closeOnClick: true
                        }
                    }) 
                }, error => {
                    console.log('error');
                    reject({
                        // The pool is not connected
                        body: this.$t("messages.poolNotConnected"),
                        config: {
                            timeout: 3000,
                            closeOnClick: true
                        }
                    })
                });
            }))
        },
    }
}
</script>
<style scoped>

.alert-info { 
    padding: 0.35rem 1.25rem;
    margin-bottom: 0.45rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Pool.vue